import reducer, { addRoutes } from "location-info";

// Define our inital state object. This could be a fetch() to an API endpoint.

export const routes = {
  filmfest: "/details/recPkxpU5hm2lfIWC",
  details: "/details/:showId",
  home: "/",
  programs: "/programs",
  programsDetail: "/programs/:programId",
  scheduleList: "/scheduleList",
  me: "/me(/:artId)",
  studentList: "/students",
  studentDetail: "/students/:studentId",
  splash: "/splash",
};
export const locInfo = reducer(undefined, addRoutes(routes));

export default {
  db: {},
  firebase: {
    config: {
      apiKey: "AIzaSyBjgTKKbxnewruHXUavkX2HhXw7AmUICn4",
      authDomain: "mgs-2022.firebaseapp.com",
      databaseURL: "https://mgs-2022-default-rtdb.firebaseio.com/",
      projectId: "mgs-2022",
      storageBucket: "mgs-2022.appspot.com",
      messagingSenderId: "478537305016",
    },
    entityType: {
      CreativeWork: true,
      ImageObject: true,
      MediaObject: true,
      ShowGroup: true,
      Show: true,
      SplashArt: true,
      Program: true,
      Location: true,
      Person: true,
      Student: true,
    },
  },
  locInfo,
};



// WEBPACK FOOTER //
// ./src/initState.js